var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Select from 'react-select';
import { XFormInputContainer } from './XFormInputContainer';
import { CssVariable } from '../../css-variables';
export function XFormInputSelect(input) {
    var value = input.value, options = input.options, formatOptionLabel = input.formatOptionLabel, label = input.label;
    function handleChange(value) {
        var _a;
        (_a = input.onChange) === null || _a === void 0 ? void 0 : _a.call(input, value);
    }
    function getOption(value) {
        return options.find(function (option) { return option.value === value; });
    }
    var defaultValue = getOption(value);
    return (React.createElement(XFormInputContainer, __assign({}, input, { className: 'XFormInputSelect' }),
        React.createElement(Select, { defaultValue: defaultValue, onChange: function (option) {
                var _a;
                handleChange((_a = getOption(option === null || option === void 0 ? void 0 : option.value)) === null || _a === void 0 ? void 0 : _a.value);
            }, label: label, options: options, formatOptionLabel: formatOptionLabel, isClearable: true, styles: {
                container: function (styles) { return (__assign(__assign({}, styles), { minWidth: 240, width: '100%' })); },
                control: function (styles) { return (__assign(__assign({}, styles), { backgroundColor: 'transparent', borderRadius: CssVariable.inputBorderRadius, height: CssVariable.inputHeight, border: 0 })); },
                input: function (styles) { return (__assign(__assign({}, styles), { color: CssVariable.colorTextPrimary })); },
                singleValue: function (styles) { return (__assign(__assign({}, styles), { color: CssVariable.colorTextPrimary })); },
                menu: function (styles) { return (__assign(__assign({}, styles), { backgroundColor: CssVariable.colorSurface, borderRadius: CssVariable.borderRadius, color: CssVariable.colorTextPrimary, zIndex: 100 })); },
                option: function (styles, _a) {
                    var isSelected = _a.isSelected;
                    return (__assign(__assign({}, styles), { backgroundColor: isSelected ? CssVariable.colorSecondary : CssVariable.colorSurface, color: CssVariable.colorTextPrimary }));
                },
            } })));
}
